angular.module('app.entity.actions.plugin-lock')
    .controller('LockEntityModalController', ['$scope', 'RecordStatesService', function($scope, RecordStatesService) {
        var vm = this;

        vm.isLocked = RecordStatesService.isLocked();
        vm.password = null;

        vm.close = function() {
            $scope.dismissThisDialog();
        };

        vm.confirm = function() {
            $scope.closeThisDialog(vm.isLocked ? null : { password: vm.password });
        };
    }]);
